import { ICorpusTree } from '../../../models/ICorpusTree';

const customSort = (a, b) => {
    if (a.isFile && !b.isFile) {
        return 1;
    } else if (!a.isFile && b.isFile) {
        return -1;
    }
    return a.url.localeCompare(b.url);
};

export const makeCorpusTree = (data) => {
    const base = { children: [] };

    for (const node of data) {
        const path = node.url.replace(/^(https?:\/\/)?/, '').split('/').filter((part) => part !== '');
        let curr = base;

        path.forEach((part, index) => {
            let child = curr.children.find((e) => e.url === part && e.isFile === false);
            const isCurrFile = node.mime_type && index === path.length - 1;

            if (!child || (child && (child.isFile !== isCurrFile))) {
                child = {
                    id: node.id,
                    index: index,
                    url: part,
                    fullUrl: node.url,
                    mimeType: node.mime_type,
                    lineIdx: node.lineIdx,
                    isFile: node.mime_type && index === path.length - 1,
                    content: node.content,
                    children: [],
                };
                curr.children.push(child);
            }

            curr = child;
        });
    }

    const sortChildren = (node) => {
        node.children.sort(customSort);
        node.children.forEach(sortChildren);
    };

    sortChildren(base);

    return {
        id: 'root',
        url: null,
        fullUrl: null,
        mimeType: null,
        lineIdx: null,
        content: [],
        children: base.children,
    };
};


(window as any).makeCorpusTree = makeCorpusTree;

export const getNodeUiId = (node) => node.children?.length === 0 ? node.id : `${node.id}-${node.url}-${node.index}`;

export function getAllElementIds(treeNode, currentLevel, maxLevel, result = []) {
    if (!treeNode) {
        return;
    }

    result.push(getNodeUiId(treeNode));

    if (currentLevel < maxLevel) {
        for (const child of treeNode.children) {
            getAllElementIds(child, currentLevel + 1, maxLevel, result);
        }
    }
}

export const getFirstDocument = (treeNode: ICorpusTree) => {
    if (!treeNode || !treeNode.children || treeNode.children.length === 0) {
        return null;
    }

    const firstChild = treeNode.children[0];

    if (!firstChild.children || firstChild.children.length === 0) {
        return firstChild;
    }

    return getFirstDocument(firstChild);
};

export function getLastPart(url) {
    const parts = url.split("/").filter(Boolean);
    return parts.length > 0 ? parts[parts.length - 1] : null;
}
